import type { CommLineItem } from "./CommissionBoard";

/**
 * Sep 25, 2026 (Books item 3) — says where a PAID commission line's number
 * comes from. "as paid" = the stored ledger row written at the click (what
 * actually went out, and what Books received). "computed" = the deal was paid
 * before the ledger existed, so the figure is recomputed from today's roster
 * and rates and can drift from the check that went out. Renders nothing for
 * pending / approved lines.
 */
export default function PaidProvenanceChip({
  item,
  className = "",
}: {
  item: Pick<CommLineItem, "stored" | "legacyPaid" | "paidAt">;
  className?: string;
}) {
  if (item.stored) {
    const when = item.paidAt ? ` · ${new Date(item.paidAt).toLocaleDateString()}` : "";
    return (
      <span
        title="Recorded at the moment it was marked paid — the amount that actually went out (and what Books received)."
        className={"inline-block text-[10px] font-semibold px-1.5 py-0.5 rounded bg-emerald-50 text-emerald-700 cursor-help " + className}
      >
        📌 as paid{when}
      </span>
    );
  }
  if (item.legacyPaid) {
    return (
      <span
        title="Paid before Sep 25, 2026, when payouts started being recorded — recomputed from today's roster and rates, so it can drift from the check that went out."
        className={"inline-block text-[10px] font-semibold px-1.5 py-0.5 rounded bg-slate-100 text-slate-500 cursor-help " + className}
      >
        ≈ computed
      </span>
    );
  }
  return null;
}
